import './style.scss'
import { Button } from 'antd'
import { FC, memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as HomeApi from '@/api/home'
import { UserStore } from '@/global-states'
import { showPlanModal } from '@/libs/util'
import { CloseOutlined } from '@ant-design/icons'

const CouponTip: FC = () => {
  const { t } = useTranslation('coupon_tip')
  const { couponTip, systemGuideStep } = UserStore
  const [coupon, setCoupon] = useState<any>()
  const [timeLeft, setTimeLeft] = useState<number>(0)

  useEffect(() => {
    !!couponTip && getClaimedCoupons()
  }, [couponTip])

  useEffect(() => {
    if (!coupon?.valid_window_seconds) return

    setTimeLeft(coupon.valid_window_seconds)

    if (coupon.valid_window_seconds > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timer)
            return 0
          }
          return prev - 1
        })
      }, 1000)

      return () => clearInterval(timer)
    }
  }, [coupon])

  const getClaimedCoupons = async () => {
    const res = await HomeApi.getClaimedCoupons()
    const c = res?.list?.find((l: any) => l.type === 1 && l.status === 2)
    if (c) {
      setCoupon(c)
    }
  }

  const formatTime = (seconds: number) => {
    const days = Math.floor(seconds / (3600 * 24))
    const hours = Math.floor((seconds % (3600 * 24)) / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = seconds % 60

    return { days, hours, minutes, secs }
  }

  if (!coupon?.id || timeLeft <= 0 || systemGuideStep > 0) {
    return null
  }

  const { days, hours, minutes, secs } = formatTime(timeLeft)

  return (
    <div className="layout-tip" onClick={() => showPlanModal()}>
      <div className="title gradient">{t('coupon_tip.title')}</div>
      <div className="time-countdown">
        <span className="desc">{t('coupon_tip.countdown_text')}</span>
        {days > 0 && (
          <>
            <span className="red right">{days}</span>
            <span className="unit">{t('coupon_tip.days_unit')}</span>
          </>
        )}
        <span className="red">{hours.toString().padStart(2, '0')}</span>
        <span className="unit">{t('coupon_tip.hours_unit')}</span>
        <span className="red">{minutes.toString().padStart(2, '0')}</span>
        <span className="unit">{t('coupon_tip.minutes_unit')}</span>
        <span className="red">{secs.toString().padStart(2, '0')}</span>
        <span className="unit">{t('coupon_tip.seconds_unit')}</span>
      </div>
      <Button className="btn" type="primary">
        {t('coupon_tip.button_text')}
      </Button>
      <CloseOutlined
        onClick={(e) => {
          e.stopPropagation()
          setCoupon(undefined)
        }}
      />
    </div>
  )
}

export default memo(CouponTip)
